import React, { useContext } from 'react'
import { Calendar, Flex, Spin, Typography } from 'antd'
import dayjs from 'dayjs'
import SpecialistContext from '../SpecialistContext'
import { t } from 'i18next'

export default function SpecialistCalendar ({ dateCellRender, headerRender, onSelect, width }) {
  const { loadMonthAvailabilities } = useContext(SpecialistContext)

  return (
    <Flex vertical style={{ maxWidth: width }}>
      <Typography.Title level={2} style={{ margin: '2em 0 1em 0', textAlign: 'center' }}>{t('Public.Specialist.dateSelection')}</Typography.Title>
      <Spin spinning={loadMonthAvailabilities} >
        <Calendar fullscreen={false} fullCellRender={dateCellRender} headerRender={headerRender} onChange={onSelect} style={{ boxShadow: '1px 1px 10px #4f5d75' }}
          validRange={[dayjs().subtract(1, 'day'), dayjs().add(60, 'day')]} />
      </Spin>
    </Flex>
  )
}
